import { render, staticRenderFns } from "./TenNav.vue?vue&type=template&id=3851cf28"
import script from "./TenNav.vue?vue&type=script&lang=js"
export * from "./TenNav.vue?vue&type=script&lang=js"
import style0 from "./TenNav.vue?vue&type=style&index=0&id=3851cf28&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports